// 购物车状态
export default {
    namespaced: true,
    state: () => {
      return {
        list: []
      }
    }
  }